import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FourOhFourComponent } from './four-oh-four/four-oh-four.component';
import { FourOhFourRoutingModule } from './four-oh-four-routing.module';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [FourOhFourComponent],
  imports: [
    CommonModule,
    RouterModule,
    FourOhFourRoutingModule
  ]
})
export class FourOhFourModule { }
